/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CallDealerModalFragment_seller$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontCallButton_seller$ref: FragmentReference;
export type StorefrontCallButton_seller = {|
  +serviceId: ?string,
  +favoritesByUser?: ?$ReadOnlyArray<?{|
    +serviceId: ?string
  |}>,
  +$fragmentRefs: CallDealerModalFragment_seller$ref,
  +$refType: StorefrontCallButton_seller$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "StorefrontCallButton_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "FragmentSpread",
      "name": "CallDealerModalFragment_seller",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "favoritesByUser",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "Favorite",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e8040a2c0a1e7911e41a6433260b787a';
module.exports = node;
